<script>
  import Seo from "$lib/components/SEO.svelte";
  import { setContext, onMount } from "svelte";
  import { gtag } from "$lib/utilities/gtm.js";
  import PageBody from "$lib/components/Page/PageBody.svelte";

  export let data;
  const contributors = data.contributorsData;
  setContext("contributors", contributors);

  onMount(async () => {
    gtag("event", "page_view", {
      page_title: "Contributors",
      page_location: location.href
    });
  });
</script>

<Seo data={data.pageEntry.fields} currentUrl={data.currentUrl} />

<PageBody body={data.pageEntry.fields.body} class="page-body last-page-element" />
